import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { Field, Form, Toast } from 'vant';
import FormItemCard from '../shared/components/form-item-card/form-item-card.vue';
import api from '@/api/api';
import router from '@/router';
import { isNull } from '@/shared/utils/utils';

@Component({
  components: {
    'FormItemCard': FormItemCard,
    [Form.name]: Form,
    [Field.name]: Field,
  }
})
export default class ConfirmMobileRefuse extends Vue {
  refuseRemark: string = '';
  offerId: any;
  submitting: boolean = false;

  mounted() {
    this.offerId = this.$route.query.offerId;
  }
  submit() {
    if (this.submitting) {
      return;
    }
    if (isNull(this.refuseRemark)) {
      this.$message.warning('拒绝原因为必填项')
      return;
    }
    this.submitting = true;
    const entity: any = {
      isAccept: false,
      refuseReason: this.refuseRemark,
      offerId: this.offerId
    }
    console.log(entity);
    api.confirmOffer(entity).finally(
      () => {
        this.submitting = false;
      }
    ).then(
      res => {
        router.push(`/submit-success?type=2`);
      }
    ).catch(error => {
      Toast(error[0])
    })
  }
}